const iframeId = 'tnt-iframe';

// Removes leading and trailing slashes from a given pathName
function sanitizePathName(pathName) {
	if (pathName == null) return '';
	return pathName.replaceAll(/^\/+|\/+$/g, '');
}

function initIFrameResizer() {
	const iframeEl = document.getElementById(iframeId);

	// Initialize the iframe-resizer
	// https://github.com/davidjbradshaw/iframe-resizer
	window.iFrameResize(
		{
			// Use taggedElement: Finds the bottom of the lowest element with a data-iframe-height attribute
			// https://github.com/davidjbradshaw/iframe-resizer#heightcalculationmethod
			heightCalculationMethod: 'taggedElement',

			// Set message callbacks
			messageCallback(messageData) {
				const message = messageData.message ?? {};

				// Received a message with 'requestParentLocation': Send the hosts url with its get params;
				// Merge the get params given in iframe.src into the url when the host url does not contain them;
				// If the iframe src contains tntpage (or page) with the path search/(id | csbus) and the host contains tntpage (or page) booking
				// then use the one from the iframe src.
				// Reason: search/(id | csbus) are for booking only integration. This entry point will initialize the booking process and redirect to booking
				// At this point the host will contain tntpage=booking; A refresh of the page will result in a call to the booking entry directly without
				// first initializing the booking process
				if (message.requestParentLocation != null) {
					const hostUrl = new URL(window.location.href);
					const iframeUrl = new URL(iframeEl.src);

					const hostPathName = sanitizePathName(
						hostUrl.searchParams.get('tntpage') || hostUrl.searchParams.get('page'),
					);
					const iframePathName = sanitizePathName(
						iframeUrl.searchParams.get('tntpage') || iframeUrl.searchParams.get('page'),
					);

					const imposeDirectBooking = /search\/(id|csbus)/.test(iframePathName) && hostPathName === 'booking';

					for (const [key, value] of iframeUrl.searchParams) {
						if ((key === 'page' || key === 'tntpage') && imposeDirectBooking)
							hostUrl.searchParams.set('tntpage', value);
						else if (!hostUrl.searchParams.has(key)) hostUrl.searchParams.set(key, value);
					}

					iframeEl.iFrameResizer.sendMessage(hostUrl.toString());
				}

				// Received a message with 'pathname' and 'search': update the parent search parameters
				else if (message.pathname != null && message.search != null) {
					const hostUrl = new URL(window.location.href);
					const pathName = sanitizePathName(message.pathname);

					// Set tntpage param from given pathname
					if (pathName === '') hostUrl.searchParams.delete('tntpage');
					else hostUrl.searchParams.set('tntpage', pathName);
					// Remove deprecated page param
					hostUrl.searchParams.delete('page');

					// Parse search as params and add each one to the hostUrl
					for (const [key, value] of new URLSearchParams(messageData.message.search)) {
						hostUrl.searchParams.set(key, value);
					}

					if (window.history.replaceState) window.history.replaceState({}, null, hostUrl.toString());
				} else if (message.replaceMainPageUrl != null) {
					window.location.replace(message.replaceMainPageUrl);
				} else if (
					message.visitMainPage != null &&
					message.integrationUrl != null &&
					message.mainPageUrl != null
				) {
					console.log('received visitMainPage: ', messageData);
					window.location.replace(
						`${message.mainPageUrl}request-cookies?integrationUrl=${encodeURIComponent(
							window.location.href,
						)}`,
					);
				}
			},
		},
		`#${iframeId}`,
	);
}

if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', initIFrameResizer);
else initIFrameResizer();
